/**
 * @generated SignedSource<<4854f05f356765ba9feb15efcece1a80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contactSessionStatsFragment$data = {
  readonly sessionStats: {
    readonly completed: number;
    readonly unattended: number;
    readonly upcoming: number;
  } | null;
  readonly " $fragmentType": "contactSessionStatsFragment";
};
export type contactSessionStatsFragment$key = {
  readonly " $data"?: contactSessionStatsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contactSessionStatsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contactSessionStatsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SessionStatsPayload",
      "kind": "LinkedField",
      "name": "sessionStats",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unattended",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "upcoming",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Contact",
  "abstractKey": null
};

(node as any).hash = "abfb09750c9a9ad0b423a9d6c3c79fb7";

export default node;
